import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NbAuthOAuth2JWTToken, NbAuthService } from '@nebular/auth';
import { Subscription } from 'rxjs';
import { KlientService } from '../../@core/http/klient.service';
import { MaterialDlaKlientaService } from '../../@core/http/material-dla-klienta-service';
import { PrzychodyKosztyService } from '../../@core/http/przychody-koszty.service';
import { TypKlienta } from '../../shared/models/klient.model';
import { MaterialDlaKlienta } from '../../shared/models/material-dla-klienta.model';
import { PrzychodyKoszty } from '../../shared/models/przychody-koszty.model';
import { TokenPayload } from '../../shared/models/token-payload.model';
import { ZakresDat } from '../../shared/models/zakres-dat.model';
import { PrzychodyKosztyWykresComponent } from './wykres/przychody-koszty-wykres.component';


@Component({
  selector: 'ngx-przychody-koszty',
  templateUrl: './przychody-koszty.component.html',
  styleUrls: ['./przychody-koszty.component.scss'],
})
export class PrzychodyKosztyComponent implements OnInit, OnDestroy {

  @ViewChild(PrzychodyKosztyWykresComponent) wykres: PrzychodyKosztyWykresComponent;

  przychodyKoszty: PrzychodyKoszty[] = [];
  okresy: string[] = [];
  przychody: number[] = [];
  koszty: number[] = [];
  materialy: MaterialDlaKlienta[] = [];
  wyswietlanieKosztow: boolean;

  zakresDat: ZakresDat;

  subscriptions: Subscription[] = [];

  user: TokenPayload;

  constructor(
    private authService: NbAuthService,
    private readonly przychodyKosztyService: PrzychodyKosztyService,
    private readonly materialDlaKlientaService: MaterialDlaKlientaService,
    private readonly klientService: KlientService,
  ) { }

  ngOnInit() {
    this.authService.onTokenChange()
      .subscribe((token: NbAuthOAuth2JWTToken) => {
        if (token.isValid()) {
          this.user = token.getAccessTokenPayload();
        }
      });

      this.materialDlaKlientaService.getWyroznioneMaterialyDlaKlienta().subscribe(response => {
        this.materialy = response;
      });
      this.klientService.getModuly().subscribe(response => {
        this.wyswietlanieKosztow = !response.nieaktywne.includes('koszty');
      });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  onChangeZmianaZakresu(zakresDat: ZakresDat) {
    this.zakresDat = zakresDat;
    this.subscriptions.push(this.przychodyKosztyService
      .getPrzychodyKoszty(zakresDat)
      .subscribe(response => {
        this.okresy.length = 0;
        this.przychody.length = 0;
        this.koszty.length = 0;

        this.przychodyKoszty = response;
        this.przychodyKoszty.forEach(pk => {
          this.okresy.push(pk.okres);
          this.przychody.push(pk.przychody);
          this.koszty.push(pk.koszty);
        });

        this.okresy = this.okresy.reverse();
        this.przychody = this.przychody.reverse();
        this.koszty = this.koszty.reverse();
        this.wykres.update();
      }),
    );
  }

  czyKlientOptima() {
    return this.user?.typ === TypKlienta.KO;
  }
}
